export const commonFormUiVersion = '4.12.3';
